import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_ORGANIZATION_CODES_LINK: {
    url: "/organizations",
    method: "get",
  },
};

const IndienenService = {
  getOrganizationCodesLink: (communityId, schoolId, absentId) => ({
    ...API_ENDPOINT.GET_ORGANIZATION_CODES_LINK,
    url: `/organizations/${communityId}/codes-link?iSchoolId=${schoolId}${
      absentId ? `&absentId=${absentId}` : ""
    }`,
  }),
};

export const useOrganizationCodesLink = (
  communityId,
  schoolId,
  absentId,
  shouldFetch = true
) =>
  useApiFetcherSWR(
    shouldFetch && communityId && schoolId
      ? IndienenService.getOrganizationCodesLink(
          communityId,
          schoolId,
          absentId
        )
      : null
  );

export default IndienenService;


// import axiosInstance from "Api";

// export const API_ENDPOINT = {
//   CREATE_REQUISITION: {
//     url: "requisition",
//     method: "post",
//   },
// };

// const RequisitionService = {
//   createRequisition: (payload) =>
//     axiosInstance.post(API_ENDPOINT.CREATE_REQUISITION.url, payload),
// };

// export default RequisitionService;